module.exports = __webpack_public_path__ + "static/media/listening_ru.703379b5.jpg";